import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import logo from '../assets/images/logo.png';
import googleimage from '../assets/images/googleimage.png';

import {
    webDetails,
    FILE_BASE_URL
} from '../api/api';

function Header() {

    const [sticky, setSticky] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [webData, setWebData] = useState(null);

    useEffect(() => {

        const handleScroll = () => {
            setSticky(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, []);

    useEffect(() => {

        webDetails()
            .then((res) => {
                setWebData(res.data.data);
            })
            .catch((err) => {
                console.log(err);
            });

    }, []);

    const getQrUrl = (qrPath) => {

        if (!qrPath) {
            return "";
        }

        return `${FILE_BASE_URL}${qrPath.replace(/^\/+/, "")}`;
    };

    const copyLink = async (link) => {

        if (!link) {
            return;
        }

        try {

            await navigator.clipboard.writeText(link);

            alert("App link copied!");

        } catch (error) {

            console.log("Copy failed:", error);

        }

    };

    return (

        <header
            className={`simple-header ${sticky ? "simple-header--sticky" : ""}`}
        >

            <div className="container">

                <div className="simple-header__container">

                    {/* Logo */}
                    <div className="simple-header__logo">

                        <NavLink
                            to="/"
                            title="Paar Digital Service"
                        >

                            <img
                                src={logo}
                                alt="Logo"
                                className="simple-header__logo-img"
                            />

                        </NavLink>

                    </div>

                    {/* Desktop Navigation */}
                    <nav className="simple-header__nav">

                        <ul className="simple-header__nav-list">

                            <li className="simple-header__nav-item">

                                <NavLink
                                    to="/"
                                    className="simple-header__nav-link"
                                >
                                    Home
                                </NavLink>

                            </li>

                            <li className="simple-header__nav-item">

                                <NavLink
                                    to="/about"
                                    className="simple-header__nav-link"
                                >
                                    About Us
                                </NavLink>

                            </li>

                            <li className="simple-header__nav-item">

                                <NavLink
                                    to="/contact"
                                    className="simple-header__nav-link"
                                >
                                    Contact Us
                                </NavLink>

                            </li>

                        </ul>

                    </nav>

                    {/* Dynamic QR Codes */}
                    <div className="headerqr">

                        {/* Business */}
                        {webData?.vendor_apk_qr && (
                            <div className="qrimageall">

                                <span className="qr-name">
                                    Business Apk
                                </span>

                                <a
                                    href={webData?.vendor_apk_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >

                                    <img
                                        src={getQrUrl(webData.vendor_apk_qr)}
                                        alt="Business APK QR"
                                    />

                                </a>

                                <button
                                    type="button"
                                    className="qr-copy-btn"
                                    onClick={() =>
                                        copyLink(webData?.vendor_apk_link)
                                    }
                                >
                                    Copy Link
                                </button>

                            </div>
                        )}

                        {/* Android */}
                        {webData?.android_apk_qr && (
                            <div className="qrimageall">

                                <span className="qr-name">
                                    Android Apk
                                </span>

                                <a
                                    href={webData?.android_apk_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >

                                    <img
                                        src={getQrUrl(webData.android_apk_qr)}
                                        alt="Android APK QR"
                                    />

                                </a>

                                <button
                                    type="button"
                                    className="qr-copy-btn"
                                    onClick={() =>
                                        copyLink(webData?.android_apk_link)
                                    }
                                >
                                    Copy Link
                                </button>

                            </div>
                        )}

                        {/* iOS */}
                        {webData?.ios_apk_qr && (
                            <div className="qrimageall">

                                <span className="qr-name">
                                    iOS Apk
                                </span>

                                <a
                                    href={webData?.ios_apk_link?.trim()}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >

                                    <img
                                        src={getQrUrl(webData.ios_apk_qr)}
                                        alt="iOS APK QR"
                                    />

                                </a>

                                <button
                                    type="button"
                                    className="qr-copy-btn"
                                    onClick={() =>
                                        copyLink(webData?.ios_apk_link?.trim())
                                    }
                                >
                                    Copy Link
                                </button>

                            </div>
                        )}

                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        className="simple-header__mobile-btn"
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle menu"
                    >

                        <span
                            className={`simple-header__hamburger ${menuOpen
                                    ? "simple-header__hamburger--active"
                                    : ""
                                }`}
                        >

                            <span className="simple-header__hamburger-line"></span>
                            <span className="simple-header__hamburger-line"></span>
                            <span className="simple-header__hamburger-line"></span>

                        </span>

                    </button>

                    {/* Mobile Navigation Overlay */}
                    <div
                        className={`simple-header__mobile-overlay ${menuOpen
                                ? "simple-header__mobile-overlay--active"
                                : ""
                            }`}
                        onClick={() => setMenuOpen(false)}
                    ></div>

                    {/* Mobile Navigation Menu */}
                    <nav
                        className={`simple-header__mobile-nav ${menuOpen
                                ? "simple-header__mobile-nav--active"
                                : ""
                            }`}
                    >

                        <div className="d-flex justify-content-between p-2">

                            <div className="simple-header__mobile-header">

                                <img
                                    src={logo}
                                    alt="Logo"
                                />

                            </div>

                            <button
                                className="simple-header__mobile-close"
                                onClick={() => setMenuOpen(false)}
                            >
                                ✕
                            </button>

                        </div>

                        <ul className="simple-header__mobile-nav-list">

                            <li className="simple-header__mobile-nav-item">

                                <a
                                    href="/"
                                    className="simple-header__mobile-nav-link"
                                    onClick={() => setMenuOpen(false)}
                                >
                                    Home
                                </a>

                            </li>

                            <li className="simple-header__mobile-nav-item">

                                <a
                                    href="/about"
                                    className="simple-header__mobile-nav-link"
                                    onClick={() => setMenuOpen(false)}
                                >
                                    About Us
                                </a>

                            </li>

                            <li className="simple-header__mobile-nav-item">

                                <a
                                    href="/contact"
                                    className="simple-header__mobile-nav-link"
                                    onClick={() => setMenuOpen(false)}
                                >
                                    Contact Us
                                </a>

                            </li>

                            <li className="simple-header__mobile-nav-item">

                                <a
                                    href="https://play.google.com/store/apps"
                                    className="simple-header__mobile-playstore-btn"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => setMenuOpen(false)}
                                >

                                    <img
                                        src={googleimage}
                                        alt="Google Play"
                                    />

                                </a>

                            </li>

                        </ul>

                    </nav>

                </div>

            </div>

        </header>
    );
}

export default Header;